<template>
  <div class="px-3 py-2 location-sidebar">
    <div :style="{marginTop:'60px'}">
      <b-form @submit="onSubmit" class="d-flex justify-content-between mt-3" novalidate>
        <b-input-group class="cityInputGroup align-items-center">
          <b-input-group-prepend>
            <b-icon-search class="lens"></b-icon-search>
          </b-input-group-prepend>
          <b-form-input
            autofocus
            id="cityInput"
            v-model="city"
            @change="validation = null"
            :state="validation"
            :placeholder="`search location`"
            required
            type="search"
          ></b-form-input>
        </b-input-group>
        <b-button class="submitBtn" type="submit" variant="primary" squared>Search</b-button>
      </b-form>
      <b-form-invalid-feedback :state="validation">City not found.</b-form-invalid-feedback>
      <div
        v-for="result in lastResults"
        :key="result.woeid"
        @click="$emit('citychange', result.woeid)"
        class="searchResult d-flex align-items-center justify-content-between mt-4"
      >
        <span>{{ result.title }}</span>
        <b-icon-chevron-right class="chevron"></b-icon-chevron-right>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconChevronRight, BIconSearch } from "bootstrap-vue";
import axios from "axios";

export default {
  name: "LocationSidebar",
  components: {
    BIconChevronRight,
    BIconSearch,
  },
  data() {
    return {
      visible: false,
      weatherData: null,
      city: "",
      apiKey: process.env.VUE_APP_WEATHER_API_KEY,
      validation: null,
      recentSearch: [
        {
          lat: 19.076191,
          lon: 72.875877,
          name: "Mumbai",
          country: "IN",
        },
        {
          lat: 18.53611,
          lon: 73.85218,
          name: "Pune",
          country: "IN",
        },
        {
          lat: 28.643999,
          lon: 77.091003,
          name: "New Delhi",
          country: "IN",
        },
      ],
    };
  },
  computed: {
    lastResults() {
      return [...this.recentSearch].reverse().slice(0, 7);
    },
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      if (!this.city) {
        alert("Please enter the search location");
        return;
      }

      try {
        const response = await axios.get(
          `https://api.openweathermap.org/geo/1.0/direct`,
          {
            params: {
              q: this.city,
              limit: 1,
              appid: this.apiKey,
            },
          }
        );

        const results = response.data;

        if (results.length === 0) {
          this.validation = false;
          return;
        }

        this.validation = true;

        const cityData = {
          name: results[0].name,
          lat: results[0].lat,
          lon: results[0].lon,
          country: results[0].country,
        };

        this.recentSearch = this.recentSearch.filter(
          (entry) => !(entry.lat === cityData.lat && entry.lon === cityData.lon)
        );
        this.recentSearch.push(cityData);

        this.city = "";

        this.$emit("citychange", cityData);
      } catch (error) {
        console.error("API error:", error);
        this.validation = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/locationSidebar.scss";
</style>